import { NextPage } from 'next';
import { Content } from '../components/ranking/ecosystem';

const RankingPage: NextPage = () => ( <Content/> );

export default RankingPage;
